/**
 * AttendanceModeSelector
 * Seletor Presencial / Online com o mesmo visual do drawer de agendamento
 * (classes modeSelector/modeBtn de AppointmentDrawer.module.css).
 * Especificação: docs/features/modalidade-de-atendimento/README.md
 */
import React from 'react';
import { ATTENDANCE_MODE_OPTIONS } from '../../utils/attendanceMode';
import drawerStyles from '../AppointmentDrawer/AppointmentDrawer.module.css';

function AttendanceModeSelector({ value, onChange }) {
  return (
    <div className={drawerStyles.modeSelector} role="radiogroup" aria-label="Modalidade">
      {ATTENDANCE_MODE_OPTIONS.map(option => (
        <button
          key={option.id}
          type="button"
          role="radio"
          aria-checked={value === option.id}
          className={`${drawerStyles.modeBtn} ${value === option.id ? drawerStyles.modeBtnActive : ''}`}
          onClick={() => onChange(option.id)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}

export default AttendanceModeSelector;
